import React from 'react';
import { Priority } from '../types';
interface PriorityBadgeProps {
  priority: Priority;
  className?: string;
}
export function PriorityBadge({
  priority,
  className = ''
}: PriorityBadgeProps) {
  let styles = '';
  let pulse = false;
  switch (priority) {
    case 'Rendah':
      styles = 'bg-[#64748B]/10 text-[#94A3B8] border-[#64748B]/30';
      break;
    case 'Sedang':
      styles = 'bg-[#00D4FF]/10 text-[#00D4FF] border-[#00D4FF]/30';
      break;
    case 'Tinggi':
      styles = 'bg-[#FFB800]/10 text-[#FFB800] border-[#FFB800]/30 glow-amber';
      break;
    case 'Sangat Tinggi':
      styles = 'bg-[#FF3B3B]/10 text-[#FF3B3B] border-[#FF3B3B]/30 glow-red';
      pulse = true;
      break;
    default:
      styles = 'bg-[#64748B]/10 text-[#94A3B8] border-[#64748B]/30';
  }
  return <span className={`inline-flex items-center px-2.5 py-0.5 rounded text-xs font-bold uppercase tracking-wider border ${styles} ${className}`} data-id="element-45">
      {pulse && <span className="w-1.5 h-1.5 rounded-full bg-[#FF3B3B] mr-1.5 animate-pulse" data-id="element-46"></span>}
      {priority}
    </span>;
}